import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { TaskTileProps } from '../interfaces';
import { BrandColors } from '../../constants';

export const TaskTileStyles = makeStyles((theme: Theme) =>
  createStyles({
    tile: {
      // IE only
      '@media screen and (-ms-high-contrast: none)': {
        flex: '0 0 auto',
        width: '100%',
        marginBottom: '1.5rem',
      },
      [`@media screen and (-ms-high-contrast: none) and (min-width: ${theme.breakpoints.values.sm}px)`]: {
        width: '48% !important',
        marginBottom: '4%',
      },
      [`@media screen and (-ms-high-contrast: none) and (min-width: ${theme.breakpoints.values.lg}px)`]: {
        width: '32% !important',
        marginBottom: '2%',
      },
    },
    tileActionArea: {
      display: 'flex !important',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      '& .MuiCardHeader-content': {
        wordBreak: 'break-word',
        paddingRight: '0.75rem',
      },
    },
    tileCard: (props: TaskTileProps) => ({
      // Colors fallback to theme primary colors i.e. container and text color
      backgroundColor: props.tiles.backgroundColor || theme.palette.background.paper,
      color: props.tiles.textColor || theme.palette.text.primary,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      height: '100%',
      borderRadius: '5px',
      boxShadow: `2px 2px 4px ${BrandColors.lightGrey40}`,
    }),
    scheduleStartTimeHat: (props: TaskTileProps) => ({
      float: 'right',
      padding: '10px',
      background: props.tiles.bannerColor || theme.palette.primary.main,
      color: props.tiles.bannerTextColor || theme.palette.primary.contrastText,
      boxShadow: `2px 0 4px ${BrandColors.lightGrey40}`,
      fontWeight: 600,
    }),
    tileBannerWrapper: {
      position: 'absolute',
    },
    tileHeader: (props: TaskTileProps) => ({
      height: 160,
      // Colors fallback to theme primary colors i.e. container color
      backgroundColor: props.task.bannerColor || theme.palette.background.paper,
    }),
    tileNavigateIcon: {
      marginTop: '1.25rem',
      fontSize: '1.25rem',
      marginRight: '0.5rem',
    },
    tileDivider: (props: TaskTileProps) => ({
      // Colors fallback to theme primary colors i.e. container and text color
      backgroundColor: props.tiles.textColor || theme.palette.text.primary,
    }),
    tileDescription: {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
      wordBreak: 'break-word',
    },
    languageSelectionOverlay: {
      backgroundColor: BrandColors.mineShaftWithOpacity9,
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
    },
    languageSelectionModal: {
      position: 'relative',
      top: '50%',
      left: '50%',
      width: '85%',
      transform: 'translate(-50%, -50%)',
    },
    textCenter: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    scheduledAssessmentBox: {
      padding: '0rem 1rem 1rem',
    },
    scheduledTask: {
      fontSize: '18px',
      fontWeight: 600,
      textAlign: 'center',
      wordBreak: 'break-word',
      lineHeight: '2rem',
    },
    lock: {
      position: 'absolute',
      display: 'inline-flex',
      // ie fix
      '@media screen and (-ms-high-contrast: none)': {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        margin: 'auto',
        width: '77px',
        height: '77px',
      },
    },
    actionIcon: {
      '& .MuiCardHeader-action': {
        marginTop: 0,
        marginRight: 0,
        textAlign: 'right',
      },
      '& .MuiCardHeader-content span': {
        color: 'inherit',
      },
    },
    timerIcon: {
      display: 'flex',
    },
    taskIcon: (props: TaskTileProps) => ({
      '& > path': {
        fill: props.tiles.iconColor || props.tiles.textColor || theme.palette.text.primary,
      },
    }),
    playIcon: {
      fontSize: '4.125rem',
    },
    timerText: (props: TaskTileProps) => ({
      fontSize: '0.75rem',
      color: props.tiles.iconColor || props.tiles.textColor || theme.palette.text.primary,
      fontWeight: 'bold',
      marginLeft: '6px',
    }),
    progressBar: (props: TaskTileProps) => ({
      backgroundColor: props.tiles.progressBarColor || BrandColors.defaultProgressBarColor,
      height: '15px',
      marginTop: '-15px',
      '@media screen and (-ms-high-contrast: none)': {
        position: 'absolute',
      },
      [theme.breakpoints.down('sm')]: {
        height: '10px',
        marginTop: '-10px',
      },
    }),
    IELockFix: {
      '@media screen and (-ms-high-contrast: none)': {
        position: 'relative',
      },
    },
    optionalTask: (props: TaskTileProps) => ({
      width: 'fit-content',
      flexGrow: 0,
      margin: '0.4375rem 0px 0px auto',
      padding: '0.1875rem 0.3125rem 0.1875rem 0.3125rem',
      borderRadius: '0.1875rem',
      backgroundColor: props.tiles.textColor || theme.palette.text.primary,
      fontSize: '0.625rem',
      fontWeight: 600,
      lineHeight: 'normal',
      textAlign: 'center',
      color: props.tiles.backgroundColor || theme.palette.background.paper,
    }),
    rrLabel: {
      fontWeight: 700,
      fontSize: '.8rem',
      lineHeight: '.7rem',
      [theme.breakpoints.up('sm')]: {
        paddingTop: '0.7rem',
      },
      '& > strong': {
        borderSpacing: '-0.11em',
        borderBottom:
          theme.palette.dialogBox?.border === 'none'
            ? `1px solid ${theme?.palette?.dialogBox.secondaryColor}`
            : theme.palette.dialogBox?.border,
      },
    },
    enableRRLabel: {
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
  }),
);
